'use client'

import { HeaderPlaceholder } from '@/components/layout/header'
import LinkHome from '@/components/links/home'

export default function Error() {
  return (
    <>
      <HeaderPlaceholder height className='bg-primary' />
      <section className='section py-20 lg:py-40 text-center'>
        <h1 className='font-bold text-2xl'>Oops! Something Went Wrong</h1>
        <p className='mt-2 mb-10 text-font-primary/70'>
          We&apos;re sorry, but the page couldn&apos;t load properly at this
          time. Please try again later or return to the{' '}
          <LinkHome className='text-primary'>homepage</LinkHome>
        </p>
      </section>
    </>
  )
}
